
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.624.165a.803.803 0 00-.782.803v12.174a.803.803 0 000 .013v3.878a.803.803 0 00.803.803.803.803 0 00.804-.803v-3.391l10.274-5.313a.803.803 0 00.057-1.395L4.07.286a.803.803 0 00-.446-.121zM4.45 2.41l8.28 5.142-8.28 4.282z","font-family":"sans-serif","overflow":"visible"}})])
          )
        }
      }
    